const apiBaseUrl = process.env.REACT_APP_BASE_URL
const apiBaseUrlV1 = process.env.REACT_APP_BASE_URL_V1

export { apiBaseUrl, apiBaseUrlV1 }